import React, { useRef, useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Navigate } from 'react-router-dom'
import { login } from '../apis/firebase'
export default function Login() {
  const email = useRef()
  const password = useRef()
  const {user} = useAuth()

  const [errormsg, setErrormsg] = useState('')
  
  const loginCB = async () => {
    try {
      
    await login(email.current.value, password.current.value)
    } catch (error) {
      if (error.code === 'auth/wrong-password') {
        setErrormsg('Wrong password')
      } else if (error.code === 'auth/invalid-credential') {
        setErrormsg('Invalid credentials')
      }
    }

    
  }

  return (
    <div className='tos secondblue-bg'>
      {user && <Navigate to='/admin'/>}
      <div className='center container'>
        <div className='blue-bg loginDiv '>
        <h1 className='yellowtext'>Log in</h1>
        <p className='yellowtext'>{errormsg}</p>'
        <div className='form'>
          <div className='input-field'>
            <input type='email' ref={email} placeholder='Email'/>
          </div>
          <div className='input-field'>
            <input type='password' ref={password} placeholder='Password'/>
          </div>

          <input type='button' className='add-to-cart' value='Log in' onClick={loginCB}/>

          
          
        </div>
        <br/>
        <a className='yellowtext forgot-password' href='https://www.youtube.com/watch?v=dQw4w9WgXcQ'>Forgot password?</a>
        
        </div>

        </div>
        </div>
    
  )
}
